"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatingBalance = validatingBalance;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _bn = _interopRequireDefault(require("bn.js"));

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _types = require("@plugnet/types");

var _drr = require("../util/drr");

var _votingBalance = require("./votingBalance");

var _votingBalancesNominatorsFor = require("./votingBalancesNominatorsFor");

// Copyright 2017-2019 @polkadot/api-derive authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function validatingBalance(api) {
  return address => {
    return (0, _rxjs.combineLatest)([(0, _votingBalance.votingBalance)(api)(address), (0, _votingBalancesNominatorsFor.votingBalancesNominatorsFor)(api)(address)]).pipe((0, _operators.map)((_ref) => {
      let [balance, nominators] = _ref;
      const nominatedBalance = nominators.reduce((total, nominatorBalance) => total.add(nominatorBalance.votingBalance), new _bn.default(0));
      return (0, _objectSpread2.default)({}, balance, {
        nominators,
        nominatedBalance: new _types.Balance(nominatedBalance),
        stakingBalance: new _types.Balance(nominatedBalance.add(balance.votingBalance))
      });
    }), (0, _drr.drr)());
  };
}